export function getBreadcrumbStyles(props) {
    var theme = props.theme;
    var effects = theme.effects;
    var styles = {
        itemLink: {
            borderRadius: effects.roundedCorner4,
            '.ms-Fabric--isFocusVisible &:focus::after': {
                borderRadius: effects.roundedCorner4,
            },
        },
    };
    return styles;
}
//# sourceMappingURL=Breadcrumb.styles.js.map